/**
 * Page format values.
 */
export enum PageFormatEnum {
	A0 = 'a0',
	A1 = 'a1',
	A2 = 'a2',
	A3 = 'a3',
	A4 = 'a4',
	A5 = 'a5',
	A6 = 'a6',
	LEGAL = 'legal',
	LETTER = 'letter',
	TABLOID = 'tabloid',
	LEDGER = 'ledger',
}
